import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ReadMore extends ThemeComponent {

    @Ref({ required: false }) truncated!: HTMLElement;
    @Ref({ required: false }) full!: HTMLElement;
    @Ref({ required: false }) readMoreButton!: HTMLElement;
    @Ref({ required: false }) readLessButton!: HTMLElement;

    init() {

        // Listen for read more button click test
        if (this.readMoreButton && this.truncated && this.full) {
            this.$listen(this.readMoreButton, 'click', () => {
                this.truncated.classList.toggle('read-more__content--truncated--hidden');
                this.full.classList.toggle('read-more__content--full--visible');
            });
        }

        // Listen for read less button click test
        if (this.readLessButton && this.truncated && this.full) {
            this.$listen(this.readLessButton, 'click', () => {
                this.truncated.classList.toggle('read-more__content--truncated--hidden');
                this.full.classList.toggle('read-more__content--full--visible');
            });
        }
    }
}
